import { ROLES, SUPER_ADMIN, cabinetPath, findPage, isCabinetRole, isNewRole } from './config';

// Route guard qoidalari (sof funksiyalar — testlanadi).
//
// /cabinet/:role/:page
//   - localStorage'dagi rol === :role       → ruxsat (o'z kabineti)
//   - localStorage'dagi rol === super_admin  → ruxsat, ko'rish rejimi (rol o'zgarmaydi)
//   - boshqalar                              → o'z bosh sahifasiga yo'naltiriladi
// /cabinets — faqat super_admin.

// Foydalanuvchining bosh sahifasi: yangi rollar — o'z kabineti, mavjud rollar — avvalgidek "/".
export function homePathFor(userRole) {
  return isNewRole(userRole) ? cabinetPath(userRole, ROLES[userRole].home) : '/';
}

export function resolveCabinetAccess({ userRole, routeRole, page }) {
  const isOwner = Boolean(userRole) && userRole === routeRole;
  const isSuper = userRole === SUPER_ADMIN;

  if (!isCabinetRole(routeRole) || (!isOwner && !isSuper)) {
    return { redirect: homePathFor(userRole) };
  }
  if (!page || !findPage(routeRole, page)) {
    return { redirect: cabinetPath(routeRole, ROLES[routeRole].home) };
  }
  return { allow: true, preview: !isOwner };
}

export function resolveCabinetsIndexAccess(userRole) {
  return userRole === SUPER_ADMIN ? { allow: true } : { redirect: homePathFor(userRole) };
}

// Joriy URL bo'yicha qaysi kabinet ko'rsatiladi (sidebar va header uchun).
// - yangi rol: har doim o'z kabineti;
// - super_admin: /cabinet/<rol>/... da shu rolni ko'rish rejimi;
// - admin va boshqa mavjud rollar: null (mavjud sidebar/header avvalgidek).
export function cabinetViewFor(userRole, pathname) {
  if (isNewRole(userRole)) return { role: userRole, preview: false };
  if (userRole !== SUPER_ADMIN) return null;
  const match = /^\/cabinet\/([^/]+)/.exec(pathname || '');
  if (!match || !isCabinetRole(match[1])) return null;
  return { role: match[1], preview: true };
}
